module.exports = __webpack_public_path__ + "img/academy_haw.960463e1.png";